var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g11, _g12, _path18, _g13, _g14, _g15, _path19, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageAddTeammates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 302.031,
    height: 430.845,
    viewBox: "0 0 302.031 430.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.ba,.be{opacity:0.3;}.aa,.ab,.ac,.ad,.ae,.af,.ag,.ah,.ai,.aj,.ak,.al,.am,.an,.ao,.ap,.aq,.ar,.c,.d,.e,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s,.t,.u,.v,.w,.x,.y,.z{fill:rgba(5,16,93,0.06);}.bk,.c{opacity:0;}.bl,.d{opacity:0.024;}.bm,.e{opacity:0.049;}.bn,.f{opacity:0.073;}.bo,.g{opacity:0.098;}.bp,.h{opacity:0.122;}.bq,.i{opacity:0.146;}.br,.j{opacity:0.171;}.bs,.k{opacity:0.195;}.bt,.l{opacity:0.22;}.bu,.m{opacity:0.244;}.bv,.n{opacity:0.268;}.bw,.o{opacity:0.293;}.bx,.p{opacity:0.317;}.by,.q{opacity:0.341;}.bz,.r{opacity:0.366;}.ca,.s{opacity:0.39;}.cb,.t{opacity:0.415;}.cc,.u{opacity:0.439;}.cd,.v{opacity:0.463;}.ce,.w{opacity:0.488;}.cf,.x{opacity:0.512;}.cg,.y{opacity:0.537;}.ch,.z{opacity:0.561;}.aa,.ci{opacity:0.585;}.ab,.cj{opacity:0.61;}.ac,.ck{opacity:0.634;}.ad,.cl{opacity:0.659;}.ae,.cm{opacity:0.683;}.af,.cn{opacity:0.707;}.ag,.co{opacity:0.732;}.ah,.cp{opacity:0.756;}.ai,.cq{opacity:0.78;}.aj,.cr{opacity:0.805;}.ak,.cs{opacity:0.829;}.al,.ct{opacity:0.854;}.am,.cu{opacity:0.878;}.an,.cv{opacity:0.902;}.ao,.cw{opacity:0.927;}.ap,.cx{opacity:0.951;}.aq,.cy{opacity:0.976;}.as{fill:url(#a);}.at{fill:#fefeff;}.au{fill:#0c4da4;}.av{fill:#1067db;}.aw{fill:#1ca2f9;}.ax,.ba,.bg,.df{fill:#05105d;}.ax{opacity:0.11;}.ay{fill:url(#b);}.az{fill:#1c6fdd;}.bb{fill:#83b5ea;}.bc{fill:url(#c);}.bd{fill:#f3f8fe;}.be{fill:#48486a;}.bf{fill:#f9b888;}.bh{fill:url(#d);}.bi{fill:url(#e);}.bj{fill:url(#f);}.bk,.bl,.bm,.bn,.bo,.bp,.bq,.br,.bs,.bt,.bu,.bv,.bw,.bx,.by,.bz,.ca,.cb,.cc,.cd,.ce,.cf,.cg,.ch,.ci,.cj,.ck,.cl,.cm,.cn,.co,.cp,.cq,.cr,.cs,.ct,.cu,.cv,.cw,.cx,.cy,.cz{fill:rgba(5,16,93,0.11);}.da{fill:#231f20;}.db{fill:url(#g);}.dc{fill:url(#h);}.dd{fill:url(#i);}.de{fill:url(#j);}.df{opacity:0.2;}.dg{fill:url(#r);}.dh{fill:#e5e9f4;}.di{fill:url(#s);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.847,
    y1: 0.929,
    x2: 0.098,
    y2: -0.013,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#1067db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ca2f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.844,
    y1: 0.992,
    x2: 0.142,
    y2: -0.011,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1067db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#4085e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#83b0ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#b8d1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#dee9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#f5f8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefeff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -5.674,
    y1: 0.5,
    x2: -4.674,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#071e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213,
    stopColor: "#092e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#0b44a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#0d52bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e57c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1.171,
    y1: 1.132,
    x2: -0.055,
    y2: -0.066,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -0.664,
    y1: 0.758,
    x2: 1.152,
    y2: 0.303,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec55e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe836"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 1.167,
    y1: 0.901,
    x2: 0.137,
    y2: -0.099,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#071e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.049,
    stopColor: "#072277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#0a3998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#0c49b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#0d53bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e57c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.967,
    y1: 1.02,
    x2: 0.105,
    y2: 0.056,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec55e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    stopColor: "#fece53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#fee736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe836"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e57c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#0d52bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#0b44a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#092e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -10.071,
    y1: 0.5,
    x2: -9.071,
    y2: 0.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -0.144,
    y1: 0.742,
    x2: 1.104,
    y2: 0.273,
    xlinkHref: "#h"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.739 55.796)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.503)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M243.916,154.429a.861.861,0,0,1-.862-.862V150.1a.862.862,0,1,1,1.723,0v3.471A.861.861,0,0,1,243.916,154.429Z",
    transform: "translate(-243.054 -149.234)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.868)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M246.316,153.044a.841.841,0,0,1-.43-.117l-3-1.736a.862.862,0,1,1,.862-1.492l3,1.736a.863.863,0,0,1-.432,1.609Z",
    transform: "translate(-242.449 -149.583)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.16 78.011)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.504)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M310.534,163.375a.861.861,0,0,1-.862-.862v-3.471a.862.862,0,1,1,1.723,0v3.471A.861.861,0,0,1,310.534,163.375Z",
    transform: "translate(-309.672 -158.18)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.868)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M312.934,161.99a.841.841,0,0,1-.43-.117l-3-1.736a.862.862,0,1,1,.862-1.492l3,1.736a.863.863,0,0,1-.432,1.609Z",
    transform: "translate(-309.066 -158.529)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(191.494)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.504)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M287.311,131.959a.86.86,0,0,1-.862-.862v-3.471a.862.862,0,1,1,1.723,0V131.1A.86.86,0,0,1,287.311,131.959Z",
    transform: "translate(-286.449 -126.764)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.868)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M289.711,130.574a.857.857,0,0,1-.432-.117l-3-1.733a.863.863,0,0,1,.862-1.495l3.007,1.736a.863.863,0,0,1-.432,1.609Z",
    transform: "translate(-285.843 -127.113)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(260.729 219.854)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.504)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M315.193,220.5a.861.861,0,0,1-.862-.862v-3.471a.862.862,0,0,1,1.723,0v3.471A.86.86,0,0,1,315.193,220.5Z",
    transform: "translate(-314.331 -215.302)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.868)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M317.591,219.112a.847.847,0,0,1-.43-.117l-3-1.733a.863.863,0,0,1,.862-1.495l3,1.736a.863.863,0,0,1-.432,1.609Z",
    transform: "translate(-313.725 -215.651)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.267 14.335)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.501)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M252.988,137.732a.862.862,0,0,1-.862-.862V133.4a.863.863,0,0,1,1.726,0v3.471A.863.863,0,0,1,252.988,137.732Z",
    transform: "translate(-252.126 -132.537)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.868)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M255.387,136.347a.848.848,0,0,1-.43-.117l-3-1.733a.863.863,0,0,1,.862-1.495l3,1.736a.863.863,0,0,1-.432,1.609Z",
    transform: "translate(-251.521 -132.886)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.975 168.112)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.504)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M232.333,199.66a.863.863,0,0,1-.862-.864v-3.469a.862.862,0,1,1,1.723,0V198.8A.863.863,0,0,1,232.333,199.66Z",
    transform: "translate(-231.471 -194.465)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.868)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M234.733,198.272a.863.863,0,0,1-.43-.114l-3.007-1.736a.862.862,0,1,1,.864-1.492l3,1.733a.862.862,0,0,1-.432,1.609Z",
    transform: "translate(-230.865 -194.814)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.605 39.425)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.261)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M309.841,150.453a1.3,1.3,0,0,1-1.3-1.3v-5.22a1.3,1.3,0,0,1,2.592,0v5.22A1.3,1.3,0,0,1,309.841,150.453Z",
    transform: "translate(-308.545 -142.641)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.304)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M313.449,148.368a1.275,1.275,0,0,1-.646-.174l-4.519-2.607a1.3,1.3,0,0,1,1.3-2.247l4.519,2.61a1.3,1.3,0,0,1-.651,2.419Z",
    transform: "translate(-307.635 -143.166)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(258.09 171.132)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.261)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M314.869,203.493a1.3,1.3,0,0,1-1.3-1.3v-5.22a1.3,1.3,0,0,1,2.592,0v5.22A1.3,1.3,0,0,1,314.869,203.493Z",
    transform: "translate(-313.573 -195.681)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.304)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M318.477,201.408a1.275,1.275,0,0,1-.646-.174l-4.519-2.607a1.3,1.3,0,0,1,1.3-2.247l4.519,2.61a1.3,1.3,0,0,1-.651,2.419Z",
    transform: "translate(-312.663 -196.206)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.59 131.059)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.26)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M216.405,187.355a1.3,1.3,0,0,1-1.3-1.3v-5.22a1.3,1.3,0,0,1,2.592,0v5.22A1.3,1.3,0,0,1,216.405,187.355Z",
    transform: "translate(-215.109 -179.543)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.305)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M220.015,185.269a1.276,1.276,0,0,1-.648-.174l-4.519-2.607a1.3,1.3,0,0,1,1.3-2.245l4.519,2.607a1.3,1.3,0,0,1-.648,2.419Z",
    transform: "translate(-214.199 -180.069)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.382 33.128)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.26)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M279.95,147.917a1.294,1.294,0,0,1-1.3-1.3V141.4a1.3,1.3,0,1,1,2.592,0v5.22A1.294,1.294,0,0,1,279.95,147.917Z",
    transform: "translate(-278.654 -140.105)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.305)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M283.56,145.834a1.3,1.3,0,0,1-.648-.174l-4.519-2.61a1.3,1.3,0,1,1,1.3-2.245l4.519,2.607a1.3,1.3,0,0,1-.648,2.421Z",
    transform: "translate(-277.744 -140.631)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M248.692,156.951c-.484-.238-.879-.042-.879.435a1.644,1.644,0,0,0,.879,1.306c.484.238.879.042.879-.435A1.64,1.64,0,0,0,248.692,156.951Z",
    transform: "translate(-150.754 -82.143)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M294.307,140.341c-.484-.238-.879-.042-.879.435a1.64,1.64,0,0,0,.879,1.306c.484.238.879.042.879-.435A1.644,1.644,0,0,0,294.307,140.341Z",
    transform: "translate(-83.1 -106.778)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M304.027,174.826c-.482-.238-.879-.042-.879.437a1.645,1.645,0,0,0,.879,1.3c.484.238.882.045.882-.435A1.647,1.647,0,0,0,304.027,174.826Z",
    transform: "translate(-68.684 -55.632)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M221.261,195.925c-.484-.238-.879-.042-.879.435a1.64,1.64,0,0,0,.879,1.306c.484.238.879.042.879-.435A1.644,1.644,0,0,0,221.261,195.925Z",
    transform: "translate(-191.439 -24.339)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M304.707,221.13c-.683-.338-1.239-.06-1.239.613a2.312,2.312,0,0,0,1.239,1.84c.68.335,1.239.06,1.239-.613A2.317,2.317,0,0,0,304.707,221.13Z",
    transform: "translate(-68.209 12.982)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M245.986,192.74c-.484-.238-.879-.042-.879.435a1.644,1.644,0,0,0,.879,1.306c.484.238.879.042.879-.437A1.64,1.64,0,0,0,245.986,192.74Z",
    transform: "translate(-154.768 -29.062)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.618,136.44c-.484-.238-.879-.045-.879.435a1.636,1.636,0,0,0,.879,1.3c.484.241.879.045.879-.434A1.64,1.64,0,0,0,241.618,136.44Z",
    transform: "translate(-161.246 -112.564)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M318.663,166.1c-.482-.238-.879-.045-.879.435a1.649,1.649,0,0,0,.879,1.306c.484.238.882.042.882-.435A1.643,1.643,0,0,0,318.663,166.1Z",
    transform: "translate(-46.977 -68.58)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M268.855,142.962c-.484-.238-.879-.045-.879.435a1.644,1.644,0,0,0,.879,1.306c.484.238.879.042.879-.437A1.64,1.64,0,0,0,268.855,142.962Z",
    transform: "translate(-120.849 -102.891)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M301.738,213.031c-.484-.241-.879-.045-.879.435a1.64,1.64,0,0,0,.879,1.3c.484.238.879.045.879-.435A1.636,1.636,0,0,0,301.738,213.031Z",
    transform: "translate(-72.079 1.03)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M232.5,144.56c-.924-.457-1.681-.082-1.681.832a3.139,3.139,0,0,0,1.681,2.493c.924.457,1.681.082,1.681-.832A3.14,3.14,0,0,0,232.5,144.56Z",
    transform: "translate(-175.953 -100.658)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M249.323,142.166c-.8-.395-1.448-.072-1.448.715a2.7,2.7,0,0,0,1.448,2.145c.795.395,1.445.072,1.445-.715A2.7,2.7,0,0,0,249.323,142.166Z",
    transform: "translate(-150.662 -104.171)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M213.718,154.374c-.795-.395-1.445-.072-1.445.715a2.7,2.7,0,0,0,1.445,2.145c.8.395,1.448.072,1.448-.715A2.7,2.7,0,0,0,213.718,154.374Z",
    transform: "translate(-203.466 -86.065)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M267.022,131.426c-.795-.395-1.448-.072-1.448.715a2.7,2.7,0,0,0,1.448,2.145c.8.395,1.448.072,1.448-.715A2.7,2.7,0,0,0,267.022,131.426Z",
    transform: "translate(-124.412 -120.1)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M295.379,154.374c-.795-.395-1.445-.072-1.445.715a2.7,2.7,0,0,0,1.445,2.145c.8.395,1.448.072,1.448-.715A2.7,2.7,0,0,0,295.379,154.374Z",
    transform: "translate(-82.35 -86.065)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M315.543,182.113c-.8-.392-1.448-.072-1.448.715a2.7,2.7,0,0,0,1.448,2.148c.795.392,1.445.07,1.445-.715A2.706,2.706,0,0,0,315.543,182.113Z",
    transform: "translate(-52.448 -44.921)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M231.134,185.152c-.8-.392-1.448-.07-1.448.718a2.7,2.7,0,0,0,1.448,2.145c.795.395,1.448.072,1.448-.715A2.709,2.709,0,0,0,231.134,185.152Z",
    transform: "translate(-177.64 -40.414)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.565 40.725)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 250.723)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M318.208,244.134,212.981,302.817,336.2,375.563l105.227-60.287Z",
    transform: "translate(-212.981 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M316.77,244.134,213.95,301.471,337.14,374.2l102.849-58.924Z",
    transform: "translate(-211.543 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M315.332,244.134,214.92,300.125l123.16,72.711,100.472-57.56Z",
    transform: "translate(-210.105 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M313.894,244.134l-98.005,54.644,123.13,72.694,98.094-56.2Z",
    transform: "translate(-208.667 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M312.457,244.134l-95.6,53.3,123.1,72.676,95.717-54.833Z",
    transform: "translate(-207.23 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M311.019,244.134l-93.191,51.952L340.9,368.745l93.339-53.47Z",
    transform: "translate(-205.792 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M309.581,244.134,218.8,294.74l123.041,72.641L432.8,315.275Z",
    transform: "translate(-204.354 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M308.144,244.134l-88.377,49.26,123.012,72.624,88.584-50.743Z",
    transform: "translate(-202.917 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M306.706,244.134l-85.97,47.914,122.982,72.606,86.207-49.379Z",
    transform: "translate(-201.479 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M305.268,244.134,221.705,290.7l122.952,72.589,83.829-48.016Z",
    transform: "translate(-200.041 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M303.83,244.134l-81.155,45.222L345.6,361.927l81.451-46.652Z",
    transform: "translate(-198.603 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M302.392,244.134,223.644,288.01l122.893,72.554,79.074-45.288Z",
    transform: "translate(-197.165 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M300.955,244.134l-76.341,42.53L347.477,359.2l76.7-43.925Z",
    transform: "translate(-195.728 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M299.517,244.134l-73.934,41.184,122.834,72.519,74.319-42.561Z",
    transform: "translate(-194.29 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M298.079,244.134l-71.527,39.838,122.8,72.5,71.942-41.2Z",
    transform: "translate(-192.852 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M296.641,244.134l-69.12,38.491L350.3,355.109l69.564-39.834Z",
    transform: "translate(-191.414 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M295.2,244.134,228.491,281.28l122.745,72.466,67.186-38.471Z",
    transform: "translate(-189.977 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M293.766,244.134l-64.305,35.8,122.716,72.449,64.809-37.107Z",
    transform: "translate(-188.539 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M292.328,244.134l-61.9,34.453,122.686,72.431,62.431-35.744Z",
    transform: "translate(-187.101 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M290.89,244.134,231.4,277.241l122.656,72.414,60.054-34.38Z",
    transform: "translate(-185.664 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M289.453,244.134,232.369,275.9,355,348.291l57.676-33.016Z",
    transform: "translate(-184.226 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M288.015,244.134l-54.677,30.415,122.6,72.379,55.3-31.653Z",
    transform: "translate(-182.788 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M286.577,244.134,234.307,273.2l122.568,72.361L409.8,315.275Z",
    transform: "translate(-181.35 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M285.139,244.134l-49.863,27.723L357.815,344.2l50.544-28.926Z",
    transform: "translate(-179.912 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M283.7,244.134l-47.455,26.377,122.508,72.327,48.166-27.562Z",
    transform: "translate(-178.475 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M282.264,244.134l-45.048,25.031,122.479,72.309,45.789-26.2Z",
    transform: "translate(-177.037 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M280.826,244.134l-42.641,23.685L360.634,340.11l43.411-24.835Z",
    transform: "translate(-175.599 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M279.388,244.134l-40.234,22.338,122.42,72.274,41.033-23.471Z",
    transform: "translate(-174.161 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M277.951,244.134l-37.827,20.993,122.39,72.256,38.656-22.108Z",
    transform: "translate(-172.724 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M276.513,244.134l-35.42,19.646,122.36,72.239,36.279-20.745Z",
    transform: "translate(-171.286 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M275.075,244.134l-33.013,18.3,122.33,72.221,33.9-19.381Z",
    transform: "translate(-169.848 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M273.637,244.134l-30.605,16.955,122.3,72.2,31.524-18.017Z",
    transform: "translate(-168.41 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M272.2,244.134,244,259.742l122.272,72.187,29.146-16.654Z",
    transform: "translate(-166.973 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M270.762,244.134,244.971,258.4l122.242,72.169,26.768-15.29Z",
    transform: "translate(-165.535 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M269.324,244.134,245.94,257.05,368.152,329.2l24.391-13.927Z",
    transform: "translate(-164.097 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M267.886,244.134,246.909,255.7l122.182,72.134,22.013-12.563Z",
    transform: "translate(-162.66 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M266.449,244.134l-18.57,10.224,122.153,72.117,19.636-11.2Z",
    transform: "translate(-161.222 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M265.011,244.134l-16.163,8.878,122.123,72.1,17.258-9.836Z",
    transform: "translate(-159.784 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M263.573,244.134l-13.755,7.532,122.094,72.081,14.881-8.472Z",
    transform: "translate(-158.346 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M262.135,244.134l-11.348,6.186,122.064,72.064,12.5-7.109Z",
    transform: "translate(-156.908 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M260.7,244.134l-8.941,4.839L373.791,321.02l10.126-5.745Z",
    transform: "translate(-155.471 -244.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M259.26,244.134l-6.534,3.494,122,72.029,7.748-4.382Z",
    transform: "translate(-154.033 -244.134)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M254.763,146.957l-1.125,5.58c-1.371.949-1.48,7.052-1.48,8.718l1.775,211.627c0,10.206,5.349,17.658,14.186,22.761l75.664,44.63c1.254.72,2.776,4.025,4.139,3.548l7.191,1.492A18.822,18.822,0,0,0,367.7,427.556V216.928c0-10.2-7.231-22.726-16.069-27.826l-71.751-41.377C270.951,142.575,263.238,141.085,254.763,146.957Z",
    transform: "translate(-250.219 -143.165)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M267.443,146.392c-8.838-5.1-16.066-.929-16.066,9.275V370.278c0,10.2,7.228,22.726,16.066,27.826L345.29,443.05c8.838,5.1,16.066.929,16.066-9.275V219.163c0-10.2-7.228-22.726-16.066-27.826Z",
    transform: "translate(-251.377 -141.608)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.95 29.452)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M294.09,172.806a1.869,1.869,0,0,1-.926-.246L268.8,158.488a1.855,1.855,0,1,1,1.855-3.213l24.367,14.07a1.854,1.854,0,0,1-.929,3.462Z",
    transform: "translate(-267.868 -155.026)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M262.286,147.718l18.837,10.876a2.139,2.139,0,0,1,1.068,1.85v3.466a10.951,10.951,0,0,0,5.475,9.481l32.274,18.634a3.752,3.752,0,0,0,5.627-3.25v-2.545a1.143,1.143,0,0,1,1.713-.988L341,193.165a26.96,26.96,0,0,1,13.481,23.349V429.42a6.288,6.288,0,0,1-9.431,5.446l-78.175-45.183a27.475,27.475,0,0,1-13.727-23.746l-.3-212.759A6.287,6.287,0,0,1,262.286,147.718Z",
    transform: "translate(-249.185 -137.675)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.463 126.243)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M283.925,224.314c-10.916-6.3-19.848-1.145-19.848,11.46s8.932,28.075,19.848,34.374,19.848,1.147,19.848-11.457S294.841,230.617,283.925,224.314Z",
    transform: "translate(-239.096 -112.313)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M283.025,203.346c-8.368-4.832-15.217-.879-15.217,8.783s6.848,21.521,15.217,26.351,15.214.879,15.214-8.783S291.391,208.176,283.025,203.346Z",
    transform: "translate(-233.562 -142.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M280.661,202.094c-10.159-5.865-18.472-1.065-18.472,10.665s8.311,26.128,18.472,31.993,18.47,1.065,18.47-10.665S290.82,207.959,280.661,202.094Z",
    transform: "translate(-241.896 -144.993)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "ay",
    cx: 16.205,
    cy: 28.068,
    rx: 16.205,
    ry: 28.068,
    transform: "translate(2.793 62.225) rotate(-29.999)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "az",
    cx: 16.205,
    cy: 28.068,
    rx: 16.205,
    ry: 28.068,
    transform: "translate(0 62.225) rotate(-29.999)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.136)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "M343.751,219.315,287.535,186.86v61.463l56.216,32.457a4.889,4.889,0,0,0,2.061.688,3.177,3.177,0,0,0,.728-.037,2.86,2.86,0,0,0,.288-.075,2.577,2.577,0,0,0,.425-.161,2.709,2.709,0,0,0,.251-.134,2.747,2.747,0,0,0,.449-.367c.032-.035.075-.06.107-.1a3.1,3.1,0,0,0,.417-.646c.037-.077.067-.159.1-.238a4.113,4.113,0,0,0,.2-.626c.022-.089.045-.176.062-.271a5.791,5.791,0,0,0,.094-1.028V228.294a11.575,11.575,0,0,0-3.171-7.343A8.869,8.869,0,0,0,343.751,219.315Z",
    transform: "translate(-245.44 -163.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "M364.715,229.438a10.7,10.7,0,0,1,4.822,8.353v46.038c0,3.062-2.17,4.316-4.822,2.784l-89.381-51.6a10.511,10.511,0,0,1-4.75-8.351l.588-45.616c.04-3.062,2.242-4.316,4.894-2.784Z",
    transform: "translate(-270.583 -177.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M366.388,285.561V239.523a10.7,10.7,0,0,0-4.822-8.351L272.917,179.99a4.478,4.478,0,0,0-1.967-.636c.7-1.768,2.486-2.3,4.571-1.1l88.649,51.18a10.7,10.7,0,0,1,4.822,8.353v46.038c0,2.275-1.2,3.546-2.9,3.422A4.693,4.693,0,0,0,366.388,285.561Z",
    transform: "translate(-270.038 -177.6)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.197 21.194)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M287.455,188.2c-8.351-4.82-15.182-.877-15.182,8.766s6.831,21.474,15.182,26.3,15.182.874,15.182-8.766S295.806,193.018,287.455,188.2Z",
    transform: "translate(-272.273 -186.139)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "M289.88,198.459l-8.522-4.291a5.089,5.089,0,0,0-7.37,4.8l.069,1.592a31.2,31.2,0,0,0,10.864,11.6,12.608,12.608,0,0,0,8.013,1.964c.122-3.042.231-6.126.189-8.512C293.071,202.67,292.512,199.785,289.88,198.459Z",
    transform: "translate(-269.739 -175.047)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M281.765,196.954a2.174,2.174,0,0,0-2.073,2.27l.427,9.59a10.31,10.31,0,0,0,4.348.37l.01-.214-.445-9.94A2.173,2.173,0,0,0,281.765,196.954Z",
    transform: "translate(-261.274 -170.102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M281.66,196.963a2.174,2.174,0,0,0-1.882,2.431l1.232,9.672a9.271,9.271,0,0,0,4.37-.084l-1.289-10.136A2.177,2.177,0,0,0,281.66,196.963Z",
    transform: "translate(-261.169 -170.111)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.321 26.564)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "M283.125,208.733q.086,0,.171-.015a2.448,2.448,0,0,0,2.118-2.736l-.894-7.01a2.444,2.444,0,1,0-4.85.618l.891,7.01A2.447,2.447,0,0,0,283.125,208.733Z",
    transform: "translate(-279.651 -196.836)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M279.453,200.378h0a1.98,1.98,0,0,0,1.86-2.086l-.256-4.48-3.946.226.256,4.48A1.977,1.977,0,0,0,279.453,200.378Z",
    transform: "translate(-265.098 -174.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M280.468,194.576l1.118.515-1.6,7.384-2.4-3.165Z",
    transform: "translate(-264.401 -173.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M279.534,200.073l-1.143-6.011-.5.029-1.622,7.184Z",
    transform: "translate(-266.355 -174.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M281.918,200.992h0a3.8,3.8,0,0,0,3.345-4.2l-.765-6.717-9.52,1.085.539,4.743A5.783,5.783,0,0,0,281.918,200.992Z",
    transform: "translate(-268.261 -180.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M274.97,192.509a5.674,5.674,0,0,1,.206-.737,3.262,3.262,0,0,1,.516-.993,3.731,3.731,0,0,1,.847-.718,5.01,5.01,0,0,1,2.515-1.068c1.922-.144,3.943-.156,5.5,1.155a2.417,2.417,0,0,1,.747,1.021.407.407,0,0,0,.065.137.354.354,0,0,0,.134.089,2.273,2.273,0,0,1,.951.593,4.1,4.1,0,0,1,.445,1.03,8.4,8.4,0,0,1,.444,2.108,10.5,10.5,0,0,1-.6,4.224c-.236.693-.661,2.344-1.582,2.463a.362.362,0,0,1-.355-.253,1.043,1.043,0,0,1-.027-.464l.179-2.091a.892.892,0,0,0-.114-.658.578.578,0,0,0-.723-.079c-.44.258-.459.837-.718,1.237a.475.475,0,0,1-.33.253c-.194.012-.328-.184-.4-.365-.425-1.085.293-2.585-.621-3.434-1.1-1.018-2.059.037-3.057.559a1.26,1.26,0,0,1-1.1.1,1.77,1.77,0,0,1-.762-1.157c-.144-.457-.5-1-1.073-.616-.228.151-.457.5-.755.283-.184-.132-.313-.78-.358-.991A3.977,3.977,0,0,1,274.97,192.509Z",
    transform: "translate(-268.412 -182.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M275.38,193.747a1.489,1.489,0,0,1,.328.656.8.8,0,0,0,.07.231c.214.372.6-.273.71-.422.427-.559,1.046-.407,1.651-.305a1.411,1.411,0,0,1,.827.338,1.527,1.527,0,0,1,.268.507,1.3,1.3,0,0,0,.283.5,1.064,1.064,0,0,0,1.172.045,2.366,2.366,0,0,0,1.194-1.383c.1-.315.2-1.408.807-1.058.449.258-.052,1.1-.074,1.48-.037.66.544,1.279.412,1.912a3.185,3.185,0,0,1-.665.986,2.427,2.427,0,0,1-.924.735,4.535,4.535,0,0,1-1.023.286,8.258,8.258,0,0,1-2.351.194,3.129,3.129,0,0,1-2.086-1,2.484,2.484,0,0,1-.5-1.629c-.02-.375-.1-.747-.117-1.125A3.942,3.942,0,0,0,275.38,193.747Z",
    transform: "translate(-267.698 -176.285)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.118 39.559)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M334.72,224.511l-48.378-27.842-.005-3.134,48.384,27.791Z",
    transform: "translate(-286.336 -193.535)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.118 50.292)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M334.72,228.744l-48.384-27.757v-3.131l48.384,27.791Z",
    transform: "translate(-286.336 -197.857)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.118 61.676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M313.25,220.968l-26.913-15.4v-3.131l26.913,15.431Z",
    transform: "translate(-286.336 -202.441)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.918 59.827)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M274,203.753c-8.348-4.82-15.179-.874-15.179,8.766s6.831,21.474,15.179,26.3,15.182.877,15.182-8.766S282.346,208.576,274,203.753Z",
    transform: "translate(-258.816 -201.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "M276.421,214.016l-8.52-4.288a5.088,5.088,0,0,0-7.37,4.8l.067,1.594a31.26,31.26,0,0,0,10.864,11.6,12.624,12.624,0,0,0,8.013,1.962c.122-3.042.231-6.126.189-8.51C279.612,218.227,279.053,215.342,276.421,214.016Z",
    transform: "translate(-256.282 -190.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M268.309,212.512a2.174,2.174,0,0,0-2.076,2.27l.427,9.59a10.321,10.321,0,0,0,4.351.37l.007-.214-.442-9.94A2.175,2.175,0,0,0,268.309,212.512Z",
    transform: "translate(-247.818 -185.661)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M268.2,212.521a2.174,2.174,0,0,0-1.882,2.431l1.229,9.672a9.281,9.281,0,0,0,4.373-.084L270.631,214.4A2.175,2.175,0,0,0,268.2,212.521Z",
    transform: "translate(-247.712 -185.67)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.318 26.563)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "M269.67,224.291q.082,0,.171-.015a2.445,2.445,0,0,0,2.116-2.734l-.891-7.012a2.446,2.446,0,0,0-4.852.618l.891,7.01A2.447,2.447,0,0,0,269.67,224.291Z",
    transform: "translate(-266.193 -212.394)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M265.995,215.936h0a1.976,1.976,0,0,0,1.86-2.086l-.256-4.48-3.946.226.256,4.48A1.977,1.977,0,0,0,265.995,215.936Z",
    transform: "translate(-251.642 -190.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M267.01,210.134l1.118.515-1.6,7.384-2.4-3.166Z",
    transform: "translate(-250.945 -189.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M266.076,215.631l-1.143-6.011-.5.029-1.622,7.184Z",
    transform: "translate(-252.898 -189.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M268.463,216.55h0a3.8,3.8,0,0,0,3.345-4.2l-.765-6.717-9.523,1.085.541,4.743A5.782,5.782,0,0,0,268.463,216.55Z",
    transform: "translate(-254.806 -195.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M261.514,208.067a5.668,5.668,0,0,1,.206-.738,3.258,3.258,0,0,1,.514-.993,3.731,3.731,0,0,1,.847-.718,5.028,5.028,0,0,1,2.515-1.068c1.922-.144,3.943-.156,5.5,1.155a2.4,2.4,0,0,1,.747,1.021.433.433,0,0,0,.065.137.373.373,0,0,0,.134.089,2.3,2.3,0,0,1,.954.594,4.085,4.085,0,0,1,.442,1.03,8.3,8.3,0,0,1,.447,2.108,10.546,10.546,0,0,1-.6,4.224c-.236.693-.661,2.347-1.584,2.463a.362.362,0,0,1-.353-.253,1.082,1.082,0,0,1-.03-.464q.089-1.043.181-2.091a.912.912,0,0,0-.114-.656.576.576,0,0,0-.723-.082c-.439.258-.462.837-.72,1.237a.47.47,0,0,1-.33.253c-.191.012-.328-.184-.4-.365-.422-1.085.3-2.585-.618-3.434-1.1-1.018-2.059.037-3.057.559a1.258,1.258,0,0,1-1.1.1,1.761,1.761,0,0,1-.76-1.157c-.146-.454-.5-1-1.075-.616-.228.151-.454.5-.755.286-.184-.134-.31-.782-.358-.993A3.977,3.977,0,0,1,261.514,208.067Z",
    transform: "translate(-254.956 -197.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M261.921,209.3a1.514,1.514,0,0,1,.33.658.74.74,0,0,0,.07.228c.211.372.6-.273.71-.422.425-.559,1.045-.407,1.651-.305a1.4,1.4,0,0,1,.824.338,1.555,1.555,0,0,1,.271.507,1.292,1.292,0,0,0,.281.5,1.064,1.064,0,0,0,1.172.045,2.363,2.363,0,0,0,1.2-1.383c.1-.315.2-1.406.807-1.058.447.258-.052,1.1-.074,1.48-.037.661.541,1.279.41,1.912a3.186,3.186,0,0,1-.666.986,2.438,2.438,0,0,1-.921.735,4.554,4.554,0,0,1-1.026.286,8.163,8.163,0,0,1-2.352.194,3.128,3.128,0,0,1-2.083-1,2.5,2.5,0,0,1-.507-1.629c-.02-.375-.1-.747-.114-1.125C261.9,210.092,262.005,209.4,261.921,209.3Z",
    transform: "translate(-254.241 -191.843)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.457 117.938)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M279.443,226.882c-7.238-4.179-13.161-.76-13.161,7.6s5.922,18.616,13.161,22.8,13.161.76,13.161-7.6S286.681,231.062,279.443,226.882Z",
    transform: "translate(-266.282 -225.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bh",
    d: "M275.413,226.877A11.341,11.341,0,0,0,269,225.124a12.4,12.4,0,0,1,5.23,1.753c7.238,4.179,13.161,14.437,13.161,22.8,0,5.674-2.731,9.061-6.747,9.354,4.656.338,7.931-3.139,7.931-9.354C288.574,241.314,282.651,231.056,275.413,226.877Z",
    transform: "translate(-262.252 -225.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bi",
    d: "M280.134,240.937l-8.155.839c-.941.1-2.118-1.142-2.118-2.227v-9.416c0-1.088,1.177-1.209,2.118-.218l8.155,8.577c.944.991.944,2.352,0,2.446l-8.155.839c-.941.1-2.118-1.142-2.118-2.227v-9.416c0-1.088,1.177-1.209,2.118-.218l8.155,8.577C281.077,239.482,281.077,240.843,280.134,240.937Z",
    transform: "translate(-260.974 -218.958)"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "M270.805,248.181a1.311,1.311,0,0,0,.467-.576l.012-.037a2.374,2.374,0,0,0,.169-.921h0V179.035h0a4.84,4.84,0,0,0-1.053-2.669,6.47,6.47,0,0,0-.482-.584,5.457,5.457,0,0,0-1.224-1.021l-17.3-9.913v73.174L269,248.074c.065.037.127.055.191.087h0a1.582,1.582,0,0,0,1.6.032Z",
    transform: "translate(-145.439 -70.278)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.146 38.688)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M216.118,144.1c.012-1.567,1.13-2.208,2.488-1.423l98.676,56.541a5.824,5.824,0,0,1,2.759,4.274v67.611c0,1.567-1.1,2.21-2.458,1.428l-99.5-56.825a5.411,5.411,0,0,1-2.448-4.271Z",
    transform: "translate(-215.631 -142.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M316.967,199.219l-98.676-56.541c-1.229-.71-2.255-.243-2.448,1.016a1.7,1.7,0,0,1,.218.1l98.676,56.541a5.823,5.823,0,0,1,2.759,4.274v67.611a2.843,2.843,0,0,1-.035.4c1.266.613,2.27-.025,2.265-1.515V203.493A5.824,5.824,0,0,0,316.967,199.219Z",
    transform: "translate(-215.316 -142.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M270.983,180.06l-40.714-23.506v11.953l40.5,23.431Z",
    transform: "translate(-193.921 -121.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M264.843,191.133,246.83,180.7v10.576l17.823,10.366Z",
    transform: "translate(-169.358 -85.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M255.113,185.549,237.1,175.116v10.576l17.823,10.366Z",
    transform: "translate(-183.79 -93.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M245.382,179.965l-18.013-10.433v10.576l17.822,10.367Z",
    transform: "translate(-198.221 -102.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M235.652,174.381l-18.013-10.433v10.576l17.823,10.366Z",
    transform: "translate(-212.653 -110.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M230.732,151.181c5.823,3.342,10.573,11.569,10.556,18.283s-4.78,9.463-10.586,6.111S220.146,164,220.146,157.292,224.909,147.838,230.732,151.181Z",
    transform: "translate(-208.934 -131.348)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 184.778)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 185.555)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "M279.171,275.9,208.726,315.62l35.222,20.794,70.445-40.177Z",
    transform: "translate(-208.726 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M278.2,275.9l-68.813,38.8L244.6,335.49l68.822-39.252Z",
    transform: "translate(-207.752 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bm",
    d: "M277.222,275.9,210.04,313.78l35.205,20.785,67.2-38.327Z",
    transform: "translate(-206.777 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bn",
    d: "M276.247,275.9,210.7,312.86l35.2,20.779,65.575-37.4Z",
    transform: "translate(-205.803 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M275.273,275.9,211.354,311.94l35.188,20.775L310.5,296.237Z",
    transform: "translate(-204.828 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bp",
    d: "M274.3,275.9,212.011,311.02l35.18,20.769,62.329-35.552Z",
    transform: "translate(-203.854 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "M273.324,275.9l-60.656,34.2,35.172,20.764,60.706-34.627Z",
    transform: "translate(-202.879 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "M272.349,275.9,213.326,309.18l35.163,20.759,59.083-33.7Z",
    transform: "translate(-201.905 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "M271.375,275.9,213.983,308.26l35.155,20.754,57.46-32.777Z",
    transform: "translate(-200.93 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "M270.4,275.9,214.64,307.34l35.146,20.749,55.837-31.852Z",
    transform: "translate(-199.956 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bu",
    d: "M269.426,275.9,215.3,306.42l35.138,20.745,54.214-30.927Z",
    transform: "translate(-198.981 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bv",
    d: "M268.452,275.9l-52.5,29.6,35.129,20.74,52.591-30Z",
    transform: "translate(-198.007 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "M267.477,275.9,216.611,304.58l35.12,20.735L302.7,296.237Z",
    transform: "translate(-197.032 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bx",
    d: "M266.5,275.9,217.268,303.66l35.112,20.73,49.345-28.152Z",
    transform: "translate(-196.058 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "by",
    d: "M265.528,275.9l-47.6,26.838,35.1,20.725,47.722-27.227Z",
    transform: "translate(-195.083 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bz",
    d: "M264.554,275.9,218.582,301.82l35.1,20.72,46.1-26.3Z",
    transform: "translate(-194.109 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ca",
    d: "M263.579,275.9l-44.34,25,35.087,20.715L298.8,296.237Z",
    transform: "translate(-193.134 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cb",
    d: "M262.6,275.9,219.9,299.98l35.078,20.71,42.853-24.452Z",
    transform: "translate(-192.16 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cc",
    d: "M261.63,275.9,220.553,299.06l35.07,20.7,41.23-23.527Z",
    transform: "translate(-191.185 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cd",
    d: "M260.656,275.9,221.21,298.14l35.062,20.7,39.606-22.6Z",
    transform: "translate(-190.211 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ce",
    d: "M259.681,275.9,221.867,297.22l35.053,20.694L294.9,296.237Z",
    transform: "translate(-189.236 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cf",
    d: "M258.707,275.9l-36.183,20.4,35.045,20.69,36.36-20.752Z",
    transform: "translate(-188.262 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "M257.732,275.9,223.181,295.38l35.036,20.685,34.737-19.827Z",
    transform: "translate(-187.287 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ch",
    d: "M256.758,275.9,223.838,294.46l35.028,20.68,33.114-18.9Z",
    transform: "translate(-186.313 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ci",
    d: "M255.783,275.9,224.5,293.54l35.019,20.674,31.491-17.977Z",
    transform: "translate(-185.339 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "M254.809,275.9,225.152,292.62l35.01,20.67,29.868-17.052Z",
    transform: "translate(-184.364 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ck",
    d: "M253.834,275.9l-28.025,15.8,35,20.665,28.245-16.127Z",
    transform: "translate(-183.389 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cl",
    d: "M252.86,275.9,226.466,290.78l34.994,20.659,26.622-15.2Z",
    transform: "translate(-182.415 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cm",
    d: "M251.885,275.9l-24.762,13.958,34.985,20.655,25-14.277Z",
    transform: "translate(-181.44 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "M250.911,275.9,227.78,288.94l34.977,20.649,23.376-13.351Z",
    transform: "translate(-180.466 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "co",
    d: "M249.936,275.9l-21.5,12.118,34.968,20.645,21.753-12.427Z",
    transform: "translate(-179.491 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cp",
    d: "M248.962,275.9l-19.867,11.2,34.96,20.64,20.13-11.5Z",
    transform: "translate(-178.517 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cq",
    d: "M247.987,275.9,229.752,286.18,264.7,306.814l18.507-10.576Z",
    transform: "translate(-177.542 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cr",
    d: "M247.013,275.9l-16.6,9.357,34.943,20.63,16.883-9.652Z",
    transform: "translate(-176.568 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cs",
    d: "M246.038,275.9l-14.973,8.437L266,304.964l15.261-8.726Z",
    transform: "translate(-175.594 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M245.064,275.9l-13.341,7.517,34.926,20.62,13.638-7.8Z",
    transform: "translate(-174.619 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cu",
    d: "M244.089,275.9l-11.71,6.6L267.3,303.114l12.014-6.876Z",
    transform: "translate(-173.645 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cv",
    d: "M243.115,275.9l-10.078,5.677,34.909,20.61,10.391-5.951Z",
    transform: "translate(-172.67 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cw",
    d: "M242.14,275.9l-8.446,4.757,34.9,20.6,8.768-5.026Z",
    transform: "translate(-171.696 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cx",
    d: "M241.166,275.9l-6.815,3.837,34.892,20.6,7.145-4.1Z",
    transform: "translate(-170.721 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cy",
    d: "M240.191,275.9l-5.183,2.917,34.884,20.595,5.522-3.176Z",
    transform: "translate(-169.747 -275.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cz",
    d: "M239.217,275.9l-3.552,2,34.875,20.59,3.9-2.251Z",
    transform: "translate(-168.772 -275.902)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.04)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.648 182.669)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M233.1,276.128l-1.145,6.995a4.858,4.858,0,0,0,2.416,4.2l.946.683a13.612,13.612,0,0,0,13.332.2L261,281.514a2.111,2.111,0,0,0,.047-3.685h0c-2.347-1.348-5.138-3.382-7.665-3.054a26.853,26.853,0,0,1-3.558.37l-5.719.777Z",
    transform: "translate(-231.958 -274.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M261,277.451l-12.346,6.692a13.606,13.606,0,0,1-13.332-.2l-.946-.683a4.858,4.858,0,0,1-2.416-4.2v1.6a4.858,4.858,0,0,0,2.416,4.2l.946.683a13.612,13.612,0,0,0,13.332.2L261,279.055a2.1,2.1,0,0,0,.931-2.657A2.072,2.072,0,0,1,261,277.451Z",
    transform: "translate(-231.958 -272.28)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.844 0.281)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.183,279.045l1.435-.71-1.718-3.481a14.354,14.354,0,0,1-1.728.119Z",
    transform: "translate(-236.102 -274.853)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M240.094,279.572l1.438-.711-1.92-3.884-1.676.228Z",
    transform: "translate(-237.936 -274.67)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.439 196.734)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M242.281,281.792l-1.145,6.995a4.858,4.858,0,0,0,2.416,4.2l.946.683a13.612,13.612,0,0,0,13.332.2l12.346-6.695a2.11,2.11,0,0,0,.045-3.685h0c-2.344-1.348-5.135-3.382-7.666-3.054a26.773,26.773,0,0,1-3.556.37l-5.719.78Z",
    transform: "translate(-241.136 -280.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M270.177,283.115,257.83,289.81a13.613,13.613,0,0,1-13.332-.2l-.946-.683a4.858,4.858,0,0,1-2.416-4.2v1.6a4.858,4.858,0,0,0,2.416,4.2l.946.683a13.612,13.612,0,0,0,13.332.2l12.346-6.695a2.1,2.1,0,0,0,.931-2.657A2.062,2.062,0,0,1,270.177,283.115Z",
    transform: "translate(-241.136 -277.944)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.844 0.281)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M250.359,284.709,251.8,284l-1.718-3.481a14.888,14.888,0,0,1-1.728.122Z",
    transform: "translate(-245.28 -280.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M249.272,285.236l1.438-.711-1.92-3.884-1.676.228Z",
    transform: "translate(-247.114 -280.334)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 31.208)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M245.09,271.6a4.12,4.12,0,0,1-2.866-1.157l-7.72-7.457a27.653,27.653,0,0,1,1.845-41.417l8.564-6.911a4.124,4.124,0,0,1,5.18,6.419l-8.567,6.911a19.41,19.41,0,0,0-1.294,29.063l7.723,7.457a4.125,4.125,0,0,1-2.866,7.092Z",
    transform: "translate(-226.059 -213.744)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.267 30.506)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M229.875,233.154a4.493,4.493,0,0,1-1.09-6.645,29.941,29.941,0,0,1,4.616-4.651l9.059-7.308a4.618,4.618,0,0,1,5.925-.025,4.454,4.454,0,0,1-.152,6.8l-9.242,7.457a20.9,20.9,0,0,0-3.337,3.389,4.4,4.4,0,0,1-5.778.981Z",
    transform: "translate(-227.777 -213.462)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.178 82.234)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M239.158,340.368c-3.985,0-5.22.494-5.22-3.491l1.023-45.68-3.6-34.911c0-3.985,3.807-21.993,7.792-21.993s12.736,8.324,12.736,12.309l-8,90.275C243.893,340.863,243.144,340.368,239.158,340.368Z",
    transform: "translate(-231.366 -234.293)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.358 97.699)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M252.577,347.836c-3.986,0-5.974-.747-5.974-4.733l-.32-48.829-8.8-46.976c0-3.986,11.112-6.777,15.1-6.777a7.216,7.216,0,0,1,7.219,7.216L258.554,343.1C258.554,347.088,256.565,347.836,252.577,347.836Z",
    transform: "translate(-237.479 -240.521)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.178 50.869)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M234.457,252.063l-3.091,22.957a8.119,8.119,0,0,0,4.06,7.032l18.827,10.573a7.556,7.556,0,0,0,11.336-6.543v-46.6c0-2.9,6.042-.9,3.529-2.354L242.7,221.878C237.663,218.97,234.457,246.245,234.457,252.063Z",
    transform: "translate(-231.366 -221.662)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(11.614 72.388)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "da",
    d: "M241.019,239.913a4.125,4.125,0,0,1-5.731,5.935l-4.552-4.4c.107-1.234.194-2.19.243-2.672.283-2.816.348-5.632.449-8.45a19.419,19.419,0,0,0,1.867,2.128Z",
    transform: "translate(-230.736 -230.328)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.832 29.685)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M231.9,227.849l2.669,22.234c-.477,4.733-.315,9.468-.792,14.2-.278,2.734-3.029,15.239-2.476,17.9.355,1.706,5.033,5.423,11.279,8.669.574.3,2.866,1.405,3.434,1.659,7.944,3.556,17.4,5.84,23.8,2.749l-1.989-22.207,1.319-16.948c.817-11.611,4.293-27.116-7.127-34.23q-.723-.451-1.48-.864l-12.155-6.635a9.272,9.272,0,0,0-9.272,0h0A14.482,14.482,0,0,0,231.9,227.849Z",
    transform: "translate(-231.226 -213.131)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.948 14.011)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M241.439,231.281a4.122,4.122,0,0,1-4.124-4.122V210.944a4.123,4.123,0,1,1,8.247,0v16.215A4.121,4.121,0,0,1,241.439,231.281Z",
    transform: "translate(-237.314 -206.819)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.357 6.062)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M0,0H20.338a0,0,0,0,1,0,0V21.261a6.211,6.211,0,0,1-6.211,6.211H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M266.146,207.063a6.251,6.251,0,0,0-1.035-5.5.7.7,0,0,0-.353-.268c-.323-.077-.571.261-.777.519-1.112,1.41-3.216,1.405-5,1.217-5.51-.586-14.186-4.355-18.564.886-.5.6-.288,1.5-.626,1.989-.43.611-.4.31-1.132.765a8.049,8.049,0,0,0-2.7,2.1c-1.942,2.672-2.17,6.29-1.378,9.5a34.325,34.325,0,0,0,4.169,8.947c1.857,3.154,5.031,10.985,8.482,4.743a11.324,11.324,0,0,0,.991-5.448,13.869,13.869,0,0,1,.747-5.505,3.019,3.019,0,0,1,1.433-1.639,1.486,1.486,0,0,1,1.919.591,2.094,2.094,0,0,1,.092,1.1c-.082.735-1.569,4.6.256,4.2.365-.077.574-.459.705-.81,1.1-2.88-.489-5.652,1.671-8.383,1.8-2.282,4.162-2,6.526-3.1A8.734,8.734,0,0,0,266.146,207.063Z",
    transform: "translate(-214.054 -201.176)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.94 11.997)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M245.44,250.79c.045,0,.092,0,.137,0l20.722-.67a20.106,20.106,0,0,0,16.868-10.327l15.3-27.692a4.106,4.106,0,1,0-7.189-3.968l-15.3,27.69a11.868,11.868,0,0,1-9.948,6.091l-20.722.67a4.106,4.106,0,0,0,.132,8.209Z",
    transform: "translate(-241.338 -206.008)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.852 47.273)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M245.619,230.755c.057,0,.112,0,.169,0l19.49-.293a5.125,5.125,0,0,0,4.954-5.289h0a5.122,5.122,0,0,0-5.287-4.954l-19.49.293a5.154,5.154,0,0,0-4.472,7.365A5.013,5.013,0,0,0,245.619,230.755Z",
    transform: "translate(-240.497 -220.214)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M261.493,214h0a.817.817,0,0,0,1.113-.3l5.043-8.788a.819.819,0,0,0-.3-1.115h0a.817.817,0,0,0-1.115.3l-5.041,8.788A.816.816,0,0,0,261.493,214Z",
    transform: "translate(-174.113 -197.454)"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.614 47.469)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "db",
    d: "M236.884,146.766h0a3.4,3.4,0,0,1,3.986-.432L311.1,186.869a4.438,4.438,0,0,1,2,3.462v49.864a2.682,2.682,0,0,1-1.974,2.587h0a1.827,1.827,0,0,1-1.4-.179l-71.371-41.2a4.43,4.43,0,0,1-2-3.459V147.96A1.617,1.617,0,0,1,236.884,146.766Z",
    transform: "translate(-236.358 -145.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M236.358,147.628c0-1.266.9-1.788,2-1.152l71.127,41.066a4.426,4.426,0,0,1,2,3.459v49.837c0,1.269-.9,1.788-2,1.152l-71.127-41.066a4.43,4.43,0,0,1-2-3.459Z",
    transform: "translate(-236.358 -145.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dc",
    d: "M243.524,153.5c-2.582-1.49-4.7-.271-4.7,2.712a10.418,10.418,0,0,0,4.7,8.132c2.582,1.49,4.693.271,4.693-2.712A10.416,10.416,0,0,0,243.524,153.5Z",
    transform: "translate(-232.695 -135.522)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dd",
    d: "M309.482,187.542l-71.127-41.066c-1.1-.636-2-.114-2,1.152v5.54l75.123,43.376V191A4.426,4.426,0,0,0,309.482,187.542Z",
    transform: "translate(-236.358 -145.399)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.123 23.748)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "M291.874,183.827l-46.607-26.891.006-1.492,46.6,26.8Z",
    transform: "translate(-245.267 -155.444)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.123 29.709)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "M291.874,186.228l-46.607-26.891.006-1.493,46.6,26.8Z",
    transform: "translate(-245.267 -157.844)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.123 35.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "M291.874,188.628l-46.607-26.891.006-1.492,46.6,26.8Z",
    transform: "translate(-245.267 -160.245)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.123 41.631)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "M291.874,191.029l-46.607-26.891.006-1.492,46.6,26.8Z",
    transform: "translate(-245.267 -162.646)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.123 47.592)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "M291.874,193.429l-46.607-26.891.006-1.492,46.6,26.8Z",
    transform: "translate(-245.267 -165.046)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.123 53.552)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "M291.874,195.83l-46.607-26.891.006-1.492,46.6,26.8Z",
    transform: "translate(-245.267 -167.447)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.123 59.513)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "M272.307,186.907l-27.04-15.568.006-1.492,27.034,15.477Z",
    transform: "translate(-245.267 -169.847)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "M238,157.1v23.357l13.485,7.786V164.884Z",
    transform: "translate(-233.918 -129.242)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.467 5.945)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M239.115,148.405c-.526-.305-.958-.057-.958.554a2.133,2.133,0,0,0,.958,1.664c.529.305.961.055.961-.554A2.129,2.129,0,0,0,239.115,148.405Z",
    transform: "translate(-238.157 -148.274)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M240.441,149.185c-.529-.305-.961-.057-.961.554a2.133,2.133,0,0,0,.961,1.664c.526.3.959.055.959-.556A2.129,2.129,0,0,0,240.441,149.185Z",
    transform: "translate(-236.195 -147.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.764,149.963c-.529-.3-.961-.055-.961.556a2.125,2.125,0,0,0,.961,1.661c.529.305.961.057.961-.554A2.133,2.133,0,0,0,241.764,149.963Z",
    transform: "translate(-234.233 -145.961)"
  })))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "df",
    d: "M291.567,182.8l3.442-1.465v-8.47a2.372,2.372,0,0,1,.122-.752v-.117a1.152,1.152,0,0,1,.345-.822c1.2-1.172,4.316-1.212,5.768-.373l24.921,14.41v30.108a4.077,4.077,0,0,1-3,3.933,2.771,2.771,0,0,1-2.118-.273l-.251-.147c-.04-.02-.077-.03-.117-.052l-25.671-14.822v-8.363l-4.375-10.511A1.75,1.75,0,0,1,291.567,182.8Z",
    transform: "translate(-87.445 -62.306)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(205.264 113.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dg",
    d: "M293.6,173.546h0c1.2-1.175,4.316-1.212,5.768-.372l83.648,48.362a5.264,5.264,0,0,1,2.374,4.11v35.186a3.287,3.287,0,0,1-2.232,3.111h0a1.275,1.275,0,0,1-1.2-.234l-86.131-49.229a5.3,5.3,0,0,1-2.57-4.008V174.365A1.146,1.146,0,0,1,293.6,173.546Z",
    transform: "translate(-288.622 -172.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M295.9,174.67c0-1.507,1.065-2.123,2.372-1.368l84.462,48.764a5.26,5.26,0,0,1,2.371,4.107v35.353c0,1.5-1.068,2.123-2.371,1.368L298.27,214.13a5.256,5.256,0,0,1-2.372-4.107V197.4l-4.375-10.511a1.755,1.755,0,0,1,.931-2.287l3.444-1.463Z",
    transform: "translate(-291.389 -172.03)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.951 14.016)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dh",
    d: "M346.274,209.525l-48.859-28.119-.005-3.165,48.864,28.067Z",
    transform: "translate(-297.41 -178.241)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.951 24.856)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dh",
    d: "M346.274,213.8,297.41,185.768v-3.162l48.864,28.067Z",
    transform: "translate(-297.41 -182.606)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.951 36.353)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dh",
    d: "M324.59,205.947,297.41,190.4v-3.162l27.181,15.585Z",
    transform: "translate(-297.41 -187.237)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "di",
    d: "M318.174,188.994l.068,30.437,21.936,12.555v-30.5Z",
    transform: "translate(-251.663 -148.277)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAddTeammates);
export default __webpack_public_path__ + "static/media/image-add-teammates.23cdc69421fb34b950b185578323da39.svg";
export { ForwardRef as ReactComponent };